import { render, staticRenderFns } from "./game-boldplay.vue?vue&type=template&id=6e7863d9&scoped=true"
import script from "./game-boldplay.vue?vue&type=script&lang=js"
export * from "./game-boldplay.vue?vue&type=script&lang=js"
import style0 from "./game-boldplay.vue?vue&type=style&index=0&id=6e7863d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7863d9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-boldplay.vue
// module id = jklU
// module chunks = 0